import { Button, Dialog, Portal } from '@chakra-ui/react';

export const EnrollmentFailureInfo = (props: any) => {
	return (
        <Dialog.Root open={props.isOpen} onOpenChange={e => {
            if (!e.open) {
                props.onClose();
            }
        }}>
            <Portal>

                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.Header>Wystąpił błąd techniczny</Dialog.Header>
                        <Dialog.CloseTrigger />
                        <Dialog.Body>
                            Nie udało się poprawnie zarejestrować zajęć, przepraszamy za
                            utrudnienia. Pracujemy nad naprawą usterki serwisu,
                            zapraszamy do zapisu na zajęcia drogą telefoniczną lub
                            mailową.
                        </Dialog.Body>
                        <Dialog.Footer>
                            <Button colorPalette="gray" mr={3} onClick={props.onClose}>
                                Zamknij
                            </Button>
                        </Dialog.Footer>
                    </Dialog.Content>
                </Dialog.Positioner>

            </Portal>
        </Dialog.Root>
    );
};
